import QueryString from "qs";
import dynamic from "next/dynamic";
import Layout from "../../../Layout";
const TechnologyPage = dynamic(
  () => import("@/Components/pages/TechnologyPage"),
);
const GhostPage = dynamic(() => import("@/Components/pages/GhostPage"));

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }
  const slug = ctx.params.slug;

  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      publicationState: "preview",
      filters: {
        slug: {
          $eq: slug,
        },
        publishedAt: {
          $null: true,
        },
      },
      populate: "deep, 8",
    },
    {
      encodeValuesOnly: false,
    },
  );
  apiRes = await fetch(`${baseUrl}technologies?${decodeURIComponent(query)}`);
  apiResData = await apiRes.json();
  isNew = apiResData.data[0].attributes.isNew ?? apiResData?.data[0]?.attributes?.design === "new";
  return {
    props: {
      apiResData,
      slug,
      isNew,
    },
  };
};

const Technology = ({ apiResData, slug }) => {
  return (
    <div id="root">
      <div>
        {apiResData.data[0].attributes.template === "ghost-page" ? (
          <GhostPage slug={slug} data={apiResData} />
        ) : (
          <TechnologyPage slug={slug} data={apiResData} />
        )}
      </div>
    </div>
  );
};
Technology.getLayout = function getLayout(page, props) {
  return (
    <Layout isNew={props.isNew} slug={props.slug}>
      {page}
    </Layout>
  );
};
export default Technology;
